// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.titulo {
  width: 80%;
}

/*BOTON OK, ACEPTAR O BUSCAR..*/
button.filtros-button-ok {
  position: fixed !important;
  right: 58px !important;
  z-index: 199;
  transition: top 0.1s ease-in;
}
button.filtros-button-ok.movil-boton-filtros {
  top: 72px !important;
  right: 15px !important;
}
button.filtros-button-ok.abierto {
  top: 145px !important;
}
button.filtros-button-ok.cerrado {
  top: 72px !important;
}

/*BOTON EXCEL*/
button.filtros-button-excel {
  position: fixed !important;
  right: 58px !important;
  z-index: 199;
  transition: top 0.1s ease-in;
}
button.filtros-button-excel i.fas {
  top: -2px;
  position: relative;
  left: 1px;
}
button.filtros-button-excel.movil-boton-filtros {
  top: 72px !important;
  right: 15px !important;
}
button.filtros-button-excel.abierto {
  top: 217px !important;
}
button.filtros-button-excel.cerrado {
  top: 72px !important;
}

/*BOTON ABRE CIERRA FILTROS*/
button.filtros-button {
  position: fixed !important;
  top: 72px !important;
  right: 58px !important;
  z-index: 200;
}
button.filtros-button.movil-boton-filtros {
  top: 72px !important;
  right: 15px !important;
}

.filtros {
  position: fixed;
  height: calc(100vh - 80px);
  width: calc(100% - 240px);
  float: inline-start;
  margin-left: 12px;
  margin-right: 12px;
  background-color: #ffffff;
  z-index: 190;
  transition: opacity 0.1s ease-in;
}
.filtros.abierto {
  opacity: 1;
  display: block;
}
.filtros.cerrado {
  opacity: 0;
  display: none;
}
.filtros.filtros-movil {
  width: 100%;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/directivas/components/hide-show/hide-show.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;AACF;;AAEA,+BAAA;AACA;EACE,0BAAA;EACA,sBAAA;EACA,YAAA;EAiBU,4BAAA;AAXZ;AALE;EACE,oBAAA;EACA,sBAAA;AAOJ;AALE;EACE,qBAAA;AAOJ;AALE;EACE,oBAAA;AAOJ;;AAGA,cAAA;AACA;EACE,0BAAA;EACA,sBAAA;EACA,YAAA;EAKQ,4BAAA;AAAV;AAEE;EACE,SAAA;EACA,kBAAA;EACA,SAAA;AAAJ;AAEE;EACE,oBAAA;EACA,sBAAA;AAAJ;AAEE;EACE,qBAAA;AAAJ;AAEE;EACE,oBAAA;AAAJ;;AAKA,4BAAA;AACA;EACE,0BAAA;EACA,oBAAA;EACA,sBAAA;EACA,YAAA;AAFF;AAGE;EACE,oBAAA;EACA,sBAAA;AADJ;;AAKA;EACE,eAAA;EACA,0BAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EAwBU,gCAAA;AArBZ;AADE;EACE,UAAA;EACA,cAAA;AAGJ;AAAE;EACE,UAAA;EACA,aAAA;AAEJ;AACE;EACE,WAAA;EACA,SAAA;AACJ","sourcesContent":[".titulo{\r\n  width: 80%;\r\n}\r\n\r\n/*BOTON OK, ACEPTAR O BUSCAR..*/\r\nbutton.filtros-button-ok {\r\n  position: fixed !important;\r\n  right: 58px !important;\r\n  z-index: 199;\r\n  &.movil-boton-filtros{\r\n    top: 72px !important;\r\n    right: 15px !important;\r\n  }\r\n  &.abierto{\r\n    top: 145px !important;\r\n  }\r\n  &.cerrado{\r\n    top: 72px !important;\r\n  }\r\n\r\n\r\n    -webkit-transition: top .1s ease-in;\r\n       -moz-transition: top .1s ease-in;\r\n        -ms-transition: top .1s ease-in;\r\n         -o-transition: top .1s ease-in;\r\n            transition: top .1s ease-in;\r\n}\r\n/*BOTON EXCEL*/\r\nbutton.filtros-button-excel {\r\n  position: fixed !important;\r\n  right: 58px !important;\r\n  z-index: 199;\r\n  -webkit-transition: top .1s ease-in;\r\n     -moz-transition: top .1s ease-in;\r\n      -ms-transition: top .1s ease-in;\r\n       -o-transition: top .1s ease-in;\r\n          transition: top .1s ease-in;\r\n\r\n  i.fas{\r\n    top: -2px;\r\n    position: relative;\r\n    left: 1px;\r\n  }\r\n  &.movil-boton-filtros{\r\n    top: 72px !important;\r\n    right: 15px !important;\r\n  }\r\n  &.abierto{\r\n    top: 217px !important;\r\n  }\r\n  &.cerrado{\r\n    top: 72px !important;\r\n  }\r\n\r\n}\r\n\r\n/*BOTON ABRE CIERRA FILTROS*/\r\nbutton.filtros-button {\r\n  position: fixed !important;\r\n  top: 72px !important;\r\n  right: 58px !important;\r\n  z-index: 200;\r\n  &.movil-boton-filtros{\r\n    top: 72px !important;\r\n    right: 15px !important;\r\n  }\r\n}\r\n\r\n.filtros{\r\n  position: fixed;\r\n  height: calc(100vh - 80px);\r\n  width: calc(100% - 240px);\r\n  float: inline-start;\r\n  margin-left: 12px;\r\n  margin-right: 12px;\r\n  background-color: #ffffff;\r\n  z-index: 190;\r\n\r\n  &.abierto {\r\n    opacity: 1;\r\n    display: block;\r\n  }\r\n\r\n  &.cerrado {\r\n    opacity: 0;\r\n    display: none;\r\n  }\r\n\r\n  &.filtros-movil {\r\n    width: 100%;\r\n    margin: 0;\r\n\r\n\r\n    // &.abierto { left:0 }\r\n    // &.cerrado { left:100vw; }\r\n  }\r\n    -webkit-transition: opacity .1s ease-in;\r\n       -moz-transition: opacity .1s ease-in;\r\n        -ms-transition: opacity .1s ease-in;\r\n         -o-transition: opacity .1s ease-in;\r\n            transition: opacity .1s ease-in;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
